import { isEarlyCacheReturnEnabled } from '../earlyCacheReturn';
import { Metrics } from '../metrics';
import { conditionalPropertyRulesPersistedPromise } from 'fdsr-migration-layer';
export const makeConditionalPropertyRulesClient = ({
  httpClient,
  rpcClient,
  persistedPromise = conditionalPropertyRulesPersistedPromise
}) => Promise.resolve({
  debug: () => {
    persistedPromise.debug();
  },
  clearCache: () => {
    persistedPromise.clearCache();
    return Promise.resolve();
  },
  get: ({
    frameworkTypeIdentifier,
    query,
    refetch = false
  }) => {
    Metrics.counter('conditionalPropertyRules.get').increment();
    return persistedPromise.makeFetchWithOpts({
      allowEagerCacheReturn: isEarlyCacheReturnEnabled(),
      refresh: refetch
    })({
      httpClient,
      rpcClient,
      frameworkTypeIdentifier,
      query
    });
  }
});